"use client";

import Link from "next/link";

export default function HomeItens({ data }) {
  const services = data?.contentAttachments2.map((item, key) => {
    return {
      idx: key + 1,
      title: item?.attachField1,
      description: item?.attachField2
    }
  });

  return (
    <section className="w-full bg-gradient-to-r from-blue-700 to-[#4B6684] h-auto md:h-[1000px] flex flex-col items-center justify-center text-white px-4 py-16">
      <div className="w-full max-w-[1440px] text-center mb-8">
        <h2 className="text-[28px] sm:text-[32px] md:text-[40px] font-semibold">
          Serviços que impulsionam seu negócio
        </h2>
      </div>

      <div className="flex justify-center mb-12">
        <img src="/assets/logos.png" alt="Logos" className="w-[200px] sm:w-[250px] md:w-[300px]" />
      </div>

      <div className="w-full max-w-[1440px] grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left mb-12">
        {services.map(item => (
            <div key={item.idx} className="flex flex-col items-center md:items-start">
              <h3 className="text-[70px] sm:text-[90px] md:text-[100px] font-thin mb-2 leading-none">
                0{item.idx}.
              </h3>
              <p className="text-[28px] sm:text-[35px] md:text-[40px] font-thin mb-4">{ item.title }</p>
              <div className="w-[80px] h-[5px] bg-white mb-4"></div>
              <ul className="text-[18px] sm:text-[20px] font-light space-y-1">
                { item.description }
              </ul>
            </div>
          )
        )}
      </div>

      <div className="w-full flex justify-center">
        <Link href="/solucoes-contabeis" className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition duration-300">
          Ver mais soluções
        </Link>
      </div>
    </section>
  );
}
